import * as React from 'react';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { emphasize, styled }, "@mui/material/Breadcrumbs": Breadcrumbs, "@mui/material/Chip": Chip, "@mui/icons-material/Home": HomeIcon, "@mui/icons-material/ExpandMore": ExpandMoreIcon } } });
export default ClientProvider;
